import DelayRangeFilter from 'components/Billing/DelayRangeFilter';
import { buildAlertIdOverride } from 'components/Billing/alertAction';
import SummaryCards from 'components/Billing/SummaryCards';
import { buildBillingColumns } from 'components/Billing/columns';
import { buildHistoryOverride } from 'components/Billing/historyAction';
import { buildRenegotiationOverride } from 'components/Billing/renegotiationTag';
import { RenegotiateButton } from 'components/Billing/renegotiateAction';
import BasicTable from 'components/Form/Table';
import TableWrapper from 'components/TableWrapper';
import ContainerAuthenticated from 'containers/Authenticated';
import { CoreContext } from 'context/CoreContext';
import useBillingList from 'hooks/useBillingList';
import { useContext, useMemo } from 'react';
import { StatusContent } from 'ui/styled';
import { BILLING_QUERIES, buildCards } from 'utils/billing';

// Ultimo degrau por atraso: acima de 60 dias, sem teto. O recorte vem da
// query (BILLING_QUERIES.renegociacao) — o front nao reclassifica nada.
//
// A regra de o contrato nao voltar para a Recuperacao ao pagar a parcela mais
// antiga e do backend: depende do historico, que a listagem nao carrega.
//
// A acao daqui tem duas saidas: renegociar ou encaminhar para a Notificacao.
// O encaminhamento e a unica forma de o contrato sair desta lista: ao entrar
// em `notificacao` ele deixa a Renegociacao e passa a aparecer na Notificacao.
export default function BillingRenegociacao() {
  const { user, setModal } = useContext(CoreContext);
  const {
    loading,
    visibleRows,
    indicators,
    delayFrom,
    setDelayFrom,
    delayTo,
    setDelayTo,
    clearDelay,
    criticalOnly,
    toggleCritical,
    reload,
  } = useBillingList({ query: BILLING_QUERIES.renegociacao });

  const columns = useMemo(
    () =>
      buildBillingColumns(
        // Mesmas colunas da Cobranca, mais a AÇÃO.
        [
          'id',
          'contrato',
          'data_emissao',
          'banco',
          'distributor',
          'integrator',
          'customer',
          'telefone',
          'parcela',
          'valor_parcelas',
          'data_vencimento',
          'dias_atraso',
          'ultima_tentativa',
          'acao',
          'historico',
        ],
        {
          user,
          overrides: {
            ...buildAlertIdOverride({ setModal, reload }),
            ...buildRenegotiationOverride(),
            ...buildHistoryOverride({ setModal, reload }),
            // Renegociar e encaminhar são do CONTRATO, não da parcela: a
            // coluna é `groupLevel`, então a célula só aparece na linha do
            // contrato.
            acao: {
              renderCell: ({ row }) => (
                <span style={{ display: 'inline-flex', gap: '6px' }}>
                  <RenegotiateButton
                    row={row}
                    setModal={setModal}
                    reload={reload}
                  />
                  <StatusContent
                    color="orange"
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      setModal({
                        type: 'billing_forward',
                        destination: 'notificacao',
                        dados: row,
                        reload,
                      });
                    }}
                    title="Encaminhar para Notificação — cancela os avisos programados"
                  >
                    Notificar
                  </StatusContent>
                </span>
              ),
            },
          },
        }
      ),
    [user, setModal, reload]
  );

  const cards = buildCards(indicators, {
    onToggleCritical: toggleCritical,
    criticalActive: criticalOnly,
  });

  return (
    <ContainerAuthenticated>
      <TableWrapper
        title="Renegociação"
        search
        filters={
          <DelayRangeFilter
            from={delayFrom}
            to={delayTo}
            onChangeFrom={setDelayFrom}
            onChangeTo={setDelayTo}
            onClear={clearDelay}
          />
        }
      >
        <SummaryCards cards={cards} />
        <BasicTable
          loading={loading}
          columns={columns}
          rows={visibleRows}
          groupBy="id"
          pagination
        />
      </TableWrapper>
    </ContainerAuthenticated>
  );
}
